export default function FormFieldsWrapper({
  label,
  children,
}: {
  label: string;
  children: React.ReactNode;
}) {
  return (
    <div className="flex flex-col gap-2">
      <label htmlFor={label} className="text-blue-900">
        {label}
      </label>
      {children}
    </div>
  );
}
